import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import App from 'antd/lib/app';
import { QueryKey } from '../../query-client';
import { fetchSiteRap, upsertSiteRap } from './index';
import { ISiteRap, IUpdateSiteRap } from './interface';

export const useSiteRapQuery = (siteId?: number) => {
    return useQuery<ISiteRap | null, Error>({
        queryKey: [QueryKey.SITE_RAPS, siteId],
        queryFn: () => fetchSiteRap(siteId!),
        enabled: !!siteId,
        retry: false,
    });
};

export const useSiteRapUpsertMutation = () => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<ISiteRap, Error, IUpdateSiteRap>({
        mutationFn: updatedSiteRap => upsertSiteRap(updatedSiteRap),
        retry: false,
        onSuccess: async siteRap => {
            await queryClient.invalidateQueries([QueryKey.SITE_RAPS, siteRap.site_id]);
        },
        onError: (error: Error) => {
            notification.error({ key: 'site-rap-update-error', message: error.message || 'Cannot update Site RAP' });
        },
    });
};
